export const ANCHORS_CONSTANTS = {
    Nome: 'Nome',
    Status: 'Status',
    Email: 'E-mail',
    Telefone1: 'Telefone 1',
    Ramal1: 'Ramal 1',
    Ddd1: 'DDD 1',
    Telefone2: 'Telefone 2',
    Ramal2: 'Ramal 2',
    Ddd2: 'DDD 2',
    ReceberEmailAntecipacoesAprovadas: 'Receber E-mail de Antecipações Aprovadas',
    ReceberEmailFechamentoMes: 'Receber E-mail de Fechamento Mês',
    AutorizaAntecipacaoTerceiros: 'Autoriza Antecipação Terceiros',
    CargoId: 'Cargo',
    AncoraContatoId: 'Ancora Contato ID',
    AncoraId: 'Ancora ID',
    DataAtualizacao: 'Data da Atualização',
  };

  export const RECEBE_EMAIL = {
    RecebePrincipal: 'Recebe Principal',
    NaoRecebe: 'Não Recebe',
    RecebeCopia: 'Recebe Cópia'
  }
